module.exports = __webpack_public_path__ + "static/media/ts.9070bac4.png";


//////////////////
// WEBPACK FOOTER
// ./src/yysChargingOperator/index/images/ts.png
// module id = 1228
// module chunks = 0